<template>
  <div class="product">
    <Banner v-if="server.top && server.top.length > 0" :info="server.top[0]" />

    <!-- 合作优势 -->
    <div class="normal">
      <h3 class="common_tit wow fadeInUp" data-wow-delay="50ms">合作优势</h3>
      <Identity v-if="server.t1 && server.t1.length > 0" :info="server.t1" />
    </div>

    <div class="shadow">
      <div class="container">
        <h3 class="common_tit wow fadeInUp" data-wow-delay="50ms">合作门槛</h3>
        <Service v-if="server.t2 && server.t2.length > 0" :info="server.t2" />
      </div>
    </div>

    <div class="normal">
      <h3 class="common_tit wow fadeInUp" data-wow-delay="50ms">合作流程</h3>
      <Advantage v-if="server.t3 && server.t3.length > 0" :info="server.t3" />
    </div>

    <div class="shadow">
      <h3 class="common_tit wow fadeInUp" data-wow-delay="50ms">合作申请</h3>
      <CopperateInput v-if="server.t4 && server.t4.length > 0" :info="server.t4" />
    </div>
  </div>
</template>

<script>
import Banner from '@/components/cooperate/banner.vue'
import Service from '@/components/cooperate/service.vue'
import Identity from '@/components/cooperate/identity.vue'
import Advantage from '@/components/cooperate/advantage.vue'
import CopperateInput from '@/components/cooperate/copperateInput.vue'

export default {
  name: 'cooperate',
  methods: {
    head() {
      return {
        title: this.seo.seoTitle || 'e签宝-合作招募',
        meta: [
          {
            hid: 'keyword',
            name: 'keyword',
            content: this.seo.seoKey || '电子签名、电子合同、电子签章、e签宝',
          },
          {
            hid: 'description',
            name: 'description',
            content:
              this.seo.seoDesc ||
              'e签宝是专业的全生态电子签名服务商。基于实名身份，为用户提供在线电子签章／签名服务的平台，并且为企业用户提供电子签名、电子合同管理、数据存证和法律维权等服务。',
          },
        ],
      }
    },
    async asyncData() {
      // let [seo, top, t1, t2, t3, t4] = await Promise.all([
      //   this.$axios.get("/api/cate/show/10").catch(() => {}), // seo
      //   this.$axios.get("/api/article/show/13001").catch(() => {}), // 仲裁顶部
      //   this.$axios.get("/api/article/show/13002").catch(() => {}), // 什么是仲裁-标题
      //   this.$axios.get("/api/article/show/13003").catch(() => {}), // 什么是仲裁-列表
      //   this.$axios.get("/api/article/show/13004").catch(() => {}), //什么是网络仲裁-标题
      //   this.$axios.get("/api/article/show/13005").catch(() => {}) // 什么是网络仲裁-列表
      // ]);

      const [seo, top, t1, t2, t3, t4] = [
        { data: [{ name: 'seo' }] },
        { data: [{ name: '首批开放授权，合作名额有限', title: 'e签宝启动渠道服务商招募计划' }] },
        {
          data: [
            {
              name: '极富想象力的利润空间',
              title: '首次售卖直接分润，续签仍享分润，不定期多多益善的营销奖励',
              smallImg: require('@/assets/images/identity/16@2x.png'),
            },
            {
              name: '未来广阔的发展前景',
              title: 'SAAS行业蓝海市场，背靠全国生态渠道体系，区域市场抢占先机',
              smallImg: require('@/assets/images/identity/31@2x.png'),
            },
            {
              name: '全面完善的支持体系',
              title: '全方面产品培训，1V1赋能培育销售；全渠道商机资源供给，全国市场活动支持',
              smallImg: require('@/assets/images/identity/14@2x.png'),
            },
          ],
        },
        {
          data: [
            { name: '可信资格', title: '具备独立的法人资格 ,有良好的商业信誉', smallImg: require('@/assets/images/service/41@2x.png') },
            {
              name: '优质资源',
              title: '渠道所在区域或行业拥有广泛市场基础、用户',
              smallImg: require('@/assets/images/service/42.svg'),
            },
            {
              name: '运营能力',
              title: '有专职人员或团队，能为用户提供必要的服务',
              smallImg: require('@/assets/images/service/44.svg'),
            },
            { name: '有效承诺', title: '签约年任务承诺，对应牌级保证金缴纳', smallImg: require('@/assets/images/service/43@2x.png') },
          ],
        },
        {
          data: [
            { name: '合作申请', smallImg: require('@/assets/images/advantage/37.svg') },
            { name: '资质审核', smallImg: require('@/assets/images/advantage/39@2x.png') },
            { name: '合同签约', smallImg: require('@/assets/images/advantage/38@2x.png') },
            { name: '培训赋能', smallImg: require('@/assets/images/advantage/46@2x.png') },
            { name: '合作开启', smallImg: require('@/assets/images/advantage/47.svg') },
          ],
        },
        { data: [{ smallImg: '' }] },
      ]

      return {
        top: top.data || [],
        t1: t1.data || [],
        t2: t2.data || [],
        t3: t3.data || [],
        t4: t4.data || [],
        seo: seo.data || {},
      }
    },
  },
  components: {
    Banner,
    Identity,
    Advantage,
    Service,
    CopperateInput,
  },
  data() {
    return {
      server: {},
      activeI: 0,
      hoverI: 0,
      globalSt: 0,
      navList: ['功能优势', '服务介绍', '技术优势', '合规资质', '相关报道'],
    }
  },
  async created() {
    this.server = await this.asyncData()
  },
}
</script>

<style lang="less" scoped>
.md {
  position: relative;
  top: -120px;
}

.solve-nav {
  box-shadow: 0px 1px 0px #e4e4e4;
  width: 100%;
  background: #fff;
  top: 60px;
  left: 0;
  z-index: 100;
  transition: all 0.4s ease-in-out;

  &.fix {
    position: fixed;
    top: 0;
  }

  .nav_i {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    a {
      flex-grow: 1;
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      transition: all 0.4s ease-in-out;

      &:hover {
        color: #e61717;
      }

      &::after {
        content: '';
        width: 0%;
        height: 3px;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        bottom: 0;
        background: #e61717;
        transition: all 0.4s ease-in-out;
      }
    }

    .line {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 3px;
      background: #e61717;
      transition: all 0.4s ease-in-out;
    }
  }
}

.normal {
  margin: 70px auto;
}

.shadow {
  padding: 70px 40px;
  background: #f6f6f9;
}

.common_tit {
  font-size: 40px;
  font-weight: bold;
  color: #000;
  line-height: 56px;
  text-align: center;
}
.sub_tit {
  font-size: 14px;
  font-weight: 400;
  color: rgba(102, 107, 128, 1);
  line-height: 26px;
  margin-top: 10px;
  text-align: center;
  padding: 0 20px;
  margin-bottom: 20px;
}

@media (max-width: 1440px) {
  .service_o {
    padding: 0 40px;
  }
}

@media (max-width: 1024px) {
  .industry,
  .program,
  .scenes,
  .sound,
  .case {
    margin: 100px auto;
  }
  .service,
  .advantage {
    margin: 100px auto;
    padding: 50px 40px;
  }
  .common_tit {
    font-size: 32px;
    line-height: 42px;
    margin-bottom: 50px;
  }
}

@media (max-width: 768px) {
  .common_tit {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 32px;
  }

  .sub_tit {
    font-size: 12px;
  }
  .solve-nav {
    top: 50px;

    .nav_i {
      display: block;
      width: 100%;
      font-size: 0;
      word-break: keep-all;
      white-space: nowrap;
      overflow: auto;
      text-align: center;

      a {
        display: inline-block;
        margin-right: 16px;
        font-size: 15px;
        height: 48px;
        line-height: 48px;
        position: relative;

        &:last-of-type {
          margin-right: 0;
        }

        &.active::after {
          width: 100%;
        }
      }

      .line {
        display: none;
      }
    }
  }

  .normal {
    margin: 50px auto;
  }
  .shadow {
    padding: 40px 10px;
    background: #f6f6f9;
  }
  .industry,
  .program,
  .scenes,
  .sound,
  .case {
    margin: 50px auto;
  }
  .service,
  .advantage {
    margin: 50px auto;
    padding: 50px 0;
  }
}
</style>
